import React, {useState} from "react"
import {Link} from "react-router-dom"
import Rescuer from "components/Rescuer"
import PhoneButtons from "components/rescuer/PhoneButtons"
import RescuerSelect from "components/rescuer/RescuerSelect"
import useRescuers from "hooks/useRescuers"
import {plural} from "utils/text_utils"
import "./Shift.css"

const getLevelLabel = (level) => {
    if (level === 'vođa_tima') return 'Vođa tima'
    if (level === 'pripravnik') return 'Pripravnik'
    if (level === 'spasilac') return 'Spasilac'
    if (level === 'instruktor') return 'Instruktor'
    return level
}

export default function Shift(props) {

    const {shift, actions, permissions} = props
    const [editMode, setEditMode] = useState(false)
    const {getUser, hasTag} = useRescuers()


    return <div id="shift">
        {shift.head && <section className="head white">
            <h3>Vođa smene</h3>

            <div className="shift-row">
                <span className="rescuer-number">1.</span>
                <Link to={`/rescuer/${shift.head.username}`}><Rescuer rescuer={shift.head}/></Link>
                <div className="right-section">
                    <div className="badges">
                        {getUser(shift.head.username)?.levels?.ski && <span className={`badge level level-${getUser(shift.head.username).levels.ski}`}>{getLevelLabel(getUser(shift.head.username).levels.ski)}</span>}
                        {getUser(shift.head.username)?.ski && <span className={`badge ski ski-${getUser(shift.head.username).ski === 'A' ? 'a' : getUser(shift.head.username).ski === 'A-' ? 'a-' : 'other'}`}>Skijanje: {getUser(shift.head.username).ski}</span>}
                        {hasTag(shift.head.username, 'tečajac') && <span className="badge trainee">Tečajac</span>}
                        {!hasTag(shift.head.username, 'tečajac') && !getUser(shift.head.username)?.ski && <span className="badge warning">Skijanje: &ndash;</span>}
                        {!hasTag(shift.head.username, 'tečajac') && !getUser(shift.head.username)?.coef && <span className="badge warning">Licenca</span>}
                        {!hasTag(shift.head.username, 'tečajac') && !getUser(shift.head.username)?.membership_paid && <span className="badge warning">Članarina</span>}
                    </div>
                    <div className="buttons">
                        <PhoneButtons phone_number={shift.head.phone_number} className="btn btn-light btn-sm"/>
                        {editMode && permissions.remove_head && !shift?.rescuers.length && <button className="btn btn-xs btn-light" onClick={event => actions.remove(shift.head)} title="Ukloni vođu smene"><i className="fas fa-times"/></button>}
                    </div>
                </div>
            </div>
            {editMode && permissions.set_head && <div className="info">Trenutni vođa smene može ovlastiti narednog</div>}
        </section>}

        {shift.rescuers && <section className="rescuers white">
            <h3>Spasioci u smeni</h3>
            {shift?.rescuers.map((rescuer, index) => <div key={rescuer.username} className="shift-row">
                <span className="rescuer-number">{index + 2}.</span>
                <Link to={`/rescuer/${rescuer.username}`}><Rescuer rescuer={rescuer}/></Link>
                <div className="right-section">
                    <div className="badges">
                        {getUser(rescuer.username)?.levels?.ski && <span className={`badge level level-${getUser(rescuer.username).levels.ski}`}>{getLevelLabel(getUser(rescuer.username).levels.ski)}</span>}
                        {hasTag(rescuer.username, 'tečajac') && <span className="badge trainee">Tečajac</span>}
                        {getUser(rescuer.username)?.ski && <span className={`badge ski ski-${getUser(rescuer.username).ski === 'A' ? 'a' : getUser(rescuer.username).ski === 'A-' ? 'a-' : 'other'}`}>Skijanje: {getUser(rescuer.username).ski}</span>}                        
                        {!hasTag(rescuer.username, 'tečajac') && !getUser(rescuer.username)?.ski && <span className="badge warning">Skijanje: &ndash;</span>}
                        {!hasTag(rescuer.username, 'tečajac') && !getUser(rescuer.username)?.coef && <span className="badge warning">Licenca</span>}
                        {!hasTag(rescuer.username, 'tečajac') && !getUser(rescuer.username)?.membership_paid && <span className="badge warning">Članarina</span>}
                    </div>
                    <div className="buttons">
                        <PhoneButtons phone_number={rescuer.phone_number} className="btn btn-light btn-sm"/>
                        {editMode && permissions.set_head && <button className="btn btn-xs btn-light" onClick={event => actions.setHead(rescuer)} title="Postavi za vođu smene"><i className="fas fa-crown"/></button>}
                        {editMode && permissions.remove && <button className="btn btn-xs btn-light" onClick={event => actions.remove(rescuer)} title="Izbaci iz smene"><i className="fas fa-times"/></button>}
                    </div>
                </div>
            </div>)}

            <div className="rescuer-count">Ukupno: {(shift.head ? 1 : 0) + shift.rescuers.length} {plural((shift.head ? 1 : 0) + shift.rescuers.length, 'spasilac', 'spasioca', 'spasilaca')}</div>

            {(permissions.add || permissions.remove || permissions.set_head || permissions.remove_head) && <button className="btn btn-light btn-sm" id="add-open" onClick={e => setEditMode(!editMode)}>
                {editMode ? <><i className="fa-solid fa-xmark"/>&nbsp;&nbsp;Zatvori</> : <><i className="fa-solid fa-pen"/>&nbsp;&nbsp;Izmeni smenu</>}
            </button>}
        </section>}

        {permissions.add && editMode && <section className="white">
            <h3>Dodaj spasioca u smenu</h3>
            <RescuerSelect onClick={actions.add}/>
        </section>}
    </div>

}